import { TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
var Superficie_proyecto_modificadoComponent = /** @class */ (function () {
    function Superficie_proyecto_modificadoComponent(fb, dialog) {
        this.fb = fb;
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            util1prim: new FormControl(''),
            util1comun: new FormControl(''),
            comun1prim: new FormControl(''),
            comun1comun: new FormControl(''),
            total1: new FormControl(''),
            util2prim: new FormControl(''),
            util2comun: new FormControl(''),
            comun2prim: new FormControl(''),
            comun2comun: new FormControl(''),
            total2: new FormControl(''),
            util3prim: new FormControl(''),
            util3comun: new FormControl(''),
            comun3prim: new FormControl(''),
            comun3comun: new FormControl(''),
            total3: new FormControl(''),
            totalt: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("superficie_proyecto_modificado"))) {
            localStorage.setItem("superficie_proyecto_modificado", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("superficie_proyecto_modificado"));
            this.form.controls['util1prim'].setValue(this.rows[0] ? this.rows[0].util1prim : '');
            this.form.controls['util1comun'].setValue(this.rows[0] ? this.rows[0].util1comun : '');
            this.form.controls['comun1prim'].setValue(this.rows[0] ? this.rows[0].comun1prim : '');
            this.form.controls['comun1comun'].setValue(this.rows[0] ? this.rows[0].comun1comun : '');
            this.form.controls['total1'].setValue(this.rows[0] ? this.rows[0].total1 : '');
            this.form.controls['util2prim'].setValue(this.rows[0] ? this.rows[0].util2prim : '');
            this.form.controls['util2comun'].setValue(this.rows[0] ? this.rows[0].util2comun : '');
            this.form.controls['comun2prim'].setValue(this.rows[0] ? this.rows[0].comun2prim : '');
            this.form.controls['comun2comun'].setValue(this.rows[0] ? this.rows[0].comun2comun : '');
            this.form.controls['total2'].setValue(this.rows[0] ? this.rows[0].total2 : '');
            this.form.controls['util3prim'].setValue(this.rows[0] ? this.rows[0].util3prim : '');
            this.form.controls['util3comun'].setValue(this.rows[0] ? this.rows[0].util3comun : '');
            this.form.controls['comun3prim'].setValue(this.rows[0] ? this.rows[0].comun3prim : '');
            this.form.controls['comun3comun'].setValue(this.rows[0] ? this.rows[0].comun3comun : '');
            this.form.controls['total3'].setValue(this.rows[0] ? this.rows[0].total3 : '');
            this.form.controls['totalt'].setValue(this.rows[0] ? this.rows[0].totalt : '');
        }
        this.superficie_anteproyecto_modificado = { util1prim: '', util1comun: '', comun1prim: '', comun1comun: '', total1: '', util2prim: '', util2comun: '', comun2prim: '', comun2comun: '', total2: '', util3prim: '', util3comun: '', comun3prim: '', comun3comun: '', total3: '', totalt: '' };
    }
    Superficie_proyecto_modificadoComponent.prototype.add_superficie_proyecto_modificado = function () {
        localStorage.setItem("superficie_proyecto_modificado", JSON.stringify([]));
        this.actualRow = localStorage.getItem("superficie_proyecto_modificado");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            util1prim: this.form.value.util1prim,
            util1comun: this.form.value.util1comun,
            comun1prim: this.form.value.comun1prim,
            comun1comun: this.form.value.comun1comun,
            total1: this.form.value.total1,
            util2prim: this.form.value.util2prim,
            util2comun: this.form.value.util2comun,
            comun2prim: this.form.value.comun2prim,
            comun2comun: this.form.value.comun2comun,
            total2: this.form.value.total2,
            util3prim: this.form.value.util3prim,
            util3comun: this.form.value.util3comun,
            comun3prim: this.form.value.comun3prim,
            comun3comun: this.form.value.comun3comun,
            total3: this.form.value.total3,
            totalt: this.form.value.totalt,
        });
        localStorage.setItem("superficie_proyecto_modificado", JSON.stringify(this.rows));
    };
    Superficie_proyecto_modificadoComponent.prototype.delete_superficie_proyecto_modificado = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("superficie_proyecto_modificado", JSON.stringify(this.rows));
            }
        }
    };
    return Superficie_proyecto_modificadoComponent;
}());
export { Superficie_proyecto_modificadoComponent };
